import React from 'react'
import classnames from 'classnames'

import type { ConductorGateVerdict } from './conductor.types'

export const VERDICT_CLASSES: Record<string, string> = {
  PASS: 'text-green-700 dark:text-green-400',
  FAIL: 'text-red-700 dark:text-red-400',
  UNKNOWN: 'text-slate-500 dark:text-slate-400',
}

export const VerdictLine: React.FC<{ verdict: ConductorGateVerdict }> = ({ verdict }) => (
  <li className="flex items-baseline gap-2 text-xs">
    <span className={classnames('w-16 shrink-0 font-semibold', VERDICT_CLASSES[verdict.verdict])}>
      {verdict.verdict}
    </span>
    <span className="font-mono">{verdict.gateId}</span>
    {verdict.failureClass != null && <span className="text-red-600 dark:text-red-400">{verdict.failureClass}</span>}
    {verdict.unknownReason != null && (
      <span className="text-slate-500 dark:text-slate-400">{verdict.unknownReason}</span>
    )}
  </li>
)
